﻿import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {config} from './config';
import {Observable, throwError} from 'rxjs';
import {map, catchError} from 'rxjs/operators';
import {ContactService} from "./contact.service";

@Injectable({providedIn: 'root'})
export class SmartSelectService {
    constructor(
        private http: HttpClient,
        public contactService: ContactService) {
    }

    smartModel = DefaultSmartRequest;
    contactModel: any;

    private handleError(error: HttpErrorResponse) {
        console.log(error);
        // return an observable with a user friendly message
        return throwError('Error! something went wrong.');
    }

    public setModel(smartModel: any) {
        this.smartModel = smartModel;
        // this.emitModelChangeEvent(model);
    }

    public resetModel() {
        this.smartModel = DefaultSmartRequest;
        // this.emitModelChangeEvent(model);
    }

    public getModel() {
        return this.smartModel;
    }


    Mail(): Observable<any> {
        this.generateMail();
        // console.log('MAIL SMART FORM ---> ', this.mailForm);
        return this.http.post(`${config.apiUrl}/php/inc/mail.php`,
            this.mailForm,
            {headers: {'Content-Type': 'application/json'}}).pipe(
            map((res) => {
                // console.log('RESPONSE ---> ',res)
                return res;
            }), catchError(this.handleError));
    }

    public mailForm: {
        from: string,
        email: string,
        text: string,
        title: string
    }

    generateMail() {
        this.contactModel = this.contactService.getModel();

        this.mailForm = <any>{};
        this.mailForm.email = this.contactModel.Email;
        this.mailForm.from = this.contactModel.Name;
        this.mailForm.title = 'SMART SELECT';
        this.mailForm.text = "" +
            "Contact information:\n" +
            "Name: " + this.contactModel.Name + "\n" +
            "Company: " + this.contactModel.Company + "\n" +
            "Country: " + this.contactModel.Country + "\n" +
            "Phone: " + this.contactModel.Phone + "\n" +
            "Email: " + this.contactModel.Email + "\n" +
            "Text: " + this.contactModel.Message + "\n\n" +

            'SMART SELECT:\n' +
            "\n Market: \n" +
            (this.smartModel.Market.VoiceWholesale ? 'Voice Wholesale,' : '') +
            (this.smartModel.Market.SMSHubbing ? 'SMS Hubbing,' : '') +
            (this.smartModel.Market.EnterpriseMessaging ? 'Enterprise Messaging,' : '') +
            (this.smartModel.Market.Custom ? 'I have in mind something else: \n' : '') +
            (this.smartModel.Market.CustomText ? this.smartModel.Market.CustomText + '\n' : '\n') +

            "\n Premises: \n" +
            (this.smartModel.Premises.SaaS ? 'Saas,' : '') +
            (this.smartModel.Premises.MyPremises ? 'My Premises,' : '') +
            (this.smartModel.Premises.Custom ? 'I have in mind an exceptional setup: \n' : '') +
            (this.smartModel.Premises.CustomText ? this.smartModel.Premises.CustomText + '\n' : '\n') +

            "\n Payment Structure: \n" +
            (this.smartModel.PaymentStructure.MRC ? 'MRC,' : '') +
            (this.smartModel.PaymentStructure.OneTime ? 'One Time,' : '') +
            (this.smartModel.PaymentStructure.InstalmentPlan ? 'Instalment Plan,' : '') +
            (this.smartModel.PaymentStructure.Custom ? 'My commercial imagination is beyond standard: \n' : '') +
            (this.smartModel.PaymentStructure.CustomText ? this.smartModel.PaymentStructure.CustomText + '\n' : '\n') +

            "\nBusiness Level: \n" +
            (this.smartModel.BusinessLevel.HelpMeToStart ? 'Help me to start,' : '') +
            (this.smartModel.BusinessLevel.MyGrowingBusiness ? 'My growing business,' : '') +
            (this.smartModel.BusinessLevel.Custom ? 'I am exceptional, fold it all up for me: \n' : '') +
            (this.smartModel.BusinessLevel.CustomText ? this.smartModel.BusinessLevel.CustomText + '\n' : '\n') +

            (this.smartModel.CustomText ? this.smartModel.CustomText + '\n' : '');

    }

}

// export const DefaultSmartRequest = {
//     Market: <any> {},
//     Premises: <any> {},
//     PaymentStructure: <any> {},
//     BusinessLevel: <any> {},
//     CustomText: ''
// };

export const DefaultSmartRequest = {
    Market: {
        VoiceWholesale: true,
        SMSHubbing: false,
        EnterpriseMessaging: false,
        Custom: false,
        CustomText: ''
    },

    Premises: {
        SaaS: true,
        MyPremises: false,
        Custom: false,
        CustomText: ''
    },

    PaymentStructure: {
        MRC: true,
        OneTime: false,
        InstalmentPlan: false,
        Custom: false,
        CustomText: ''
    },

    BusinessLevel: {
        HelpMeToStart: true,
        MyGrowingBusiness: false,
        Custom: false,
        CustomText: ''
    }
    ,
    CustomText: ''
};


